<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="用户ID" prop="userId"><el-input v-model="form.userId" placeholder="用户ID" /></el-form-item>
      <el-form-item label="日记ID" prop="diaryId"><el-input v-model="form.diaryId" placeholder="日记ID" /></el-form-item>
      <el-form-item label="场景" prop="scene">
        <el-select v-model="form.scene" placeholder="场景">
          <el-option label="察觉" value="diary" />
          <el-option label="手记" value="handnote" />
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="insightType">
        <el-select v-model="form.insightType" placeholder="类型">
          <el-option label="认知发现" value="认知发现" />
          <el-option label="情绪探索" value="情绪探索" />
          <el-option label="行为洞察" value="行为洞察" />
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="title"><el-input v-model="form.title" placeholder="标题" /></el-form-item>
      <el-form-item label="内容" prop="content"><el-input type="textarea" :rows="3" v-model="form.content" placeholder="内容" /></el-form-item>
      <el-form-item label="故事线索" prop="storyText"><el-input type="textarea" :rows="3" v-model="form.storyText" placeholder="故事线索" /></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operainsightWindow', extends: BaseOpera, components: { GlobalWindow },
  data() {
    return {
      form: { id: null, userId: '', diaryId: '', scene: 'diary', insightType: '', title: '', content: '', storyText: '' },
      rules: {}
    }
  },
  created() { this.config({ api: '/rentHouse/insight', 'field.id': 'id' }) }
}
</script>